export var TransactionModeEnum;
(function (TransactionModeEnum) {
    TransactionModeEnum["STANDALONE"] = "STANDALONE";
    TransactionModeEnum["SWAP"] = "SWAP";
    TransactionModeEnum["SIDE_EFFECT"] = "SIDE_EFFECT";
    TransactionModeEnum["DIRECT_CRYPTO"] = "DIRECT_CRYPTO";
})(TransactionModeEnum || (TransactionModeEnum = {}));
//# sourceMappingURL=transaction-mode.enum.js.map